// ============================================================================
// Workspace todosLeadDays — synchronous cache.
// ----------------------------------------------------------------------------
// `deriveChecklistTimeStatus` needs the workspace's admin-configured lead
// time on every projection pass, but the checklistViewAdapter is synchronous
// and doesn't own a settings subscription. Whichever surface subscribes to
// WorkspaceRecurringSettings (TimelineContext / ChecklistsShell / etc.)
// primes this cache; the projection reads from it without an async hop.
//
// Missing entries fall back to 0 — the safest default (no early "active"
// window, matches pre-refactor behavior).
// ============================================================================
const CACHE = new Map<string, number>()

/** Update a workspace's cached lead-days. Pass null/undefined to clear. */
export const primeTodosLeadDays = (
  workspaceId: string | null | undefined,
  leadDays: number | null | undefined,
): void => {
  if (!workspaceId) return
  if (leadDays == null) {
    CACHE.delete(workspaceId)
    return
  }
  const clamped = Math.max(0, Math.floor(leadDays))
  CACHE.set(workspaceId, clamped)
}

/** Read the cached lead-days for a workspace. Returns 0 when unset. */
export const getCachedTodosLeadDays = (workspaceId: string | null | undefined): number => {
  if (!workspaceId) return 0
  return CACHE.get(workspaceId) ?? 0
}

/** Test helper — drop everything. */
export const __resetTodosLeadDaysCacheForTests = (): void => {
  CACHE.clear()
}
